<template>
  <div class="daily-report-container">
    <!-- 顶部标签页 -->
    <div class="report-tabs">
      <div class="tab-item" :class="{ active: activeTab === 'myReport' }" @click="switchTab('myReport')">
        我的填报
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'reportApproval' }" @click="switchTab('reportApproval')">
        填报审批
      </div>
    </div>

    <!-- 我的填报内容 -->
    <div v-if="activeTab === 'myReport'" class="tab-content">
      <!-- 搜索筛选区域 -->
      <div class="filter-section">
        <div class="filter-row">
          <el-date-picker
            v-model="myReportFilters.timeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            class="date-picker-input">
          </el-date-picker>
          <el-select placeholder="全部状态" v-model="myReportFilters.status" class="filter-select">
            <el-option label="全部状态" value=""></el-option>
            <el-option label="待审核" value="1"></el-option>
            <el-option label="审核通过" value="2"></el-option>
            <el-option label="审核驳回" value="9"></el-option>
          </el-select>
          <el-button type="primary" plain @click="handleMyReportSearch" class="filter-button">查询</el-button>
          <el-button plain @click="handleMyReportReset" class="filter-button">重置</el-button>
          <div class="spacer"></div>
          <el-button 
            :type="dailyReportStatus.completed ? 'info' : 'primary'" 
            :disabled="dailyReportStatus.completed"
            @click="handleDailyReport" 
            class="report-btn">
            {{ dailyReportStatus.completed ? '当日已完成填报' : dailyReportStatus.pendingCount > 0 ? `今日健康填报 (${dailyReportStatus.pendingCount})` : '今日健康填报' }}
          </el-button>
        </div>
      </div>

      <!-- 数据表格 -->
      <el-table :data="myReportData" border stripe style="width: 100%">
        <el-table-column prop="formName" label="填报模版名称" width="150" align="center"></el-table-column>
        <el-table-column prop="name" label="填报人" width="100" align="center"></el-table-column>
        <el-table-column prop="department" label="所在部门" width="120" align="center"></el-table-column>
        <el-table-column prop="team" label="所在班组" width="120" align="center"></el-table-column>
        <el-table-column prop="fillTypeName" label="填报类型" width="100" align="center"></el-table-column>
        <el-table-column prop="healthStatus" label="健康评级" width="100" align="center">
          <template slot-scope="scope">
            <span :class="{ 'status-normal': scope.row.healthStatus === '正常' }">
              {{ scope.row.healthStatus }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="measureDetail" label="排查情况" min-width="180" align="center"></el-table-column>
        <el-table-column prop="controlMeasure" label="管控措施" min-width="180" align="center"></el-table-column>
        <el-table-column prop="healthScore" label="健康评分" width="100" align="center"></el-table-column>
        <el-table-column prop="reportStatus" label="填报状态" width="100" align="center">
          <template slot-scope="scope">
            <span :class="getStatusClass(scope.row.reportStatus)">
              {{ scope.row.reportStatus }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="reportTime" label="填报时间" width="180" align="center"></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.reportStatus !== '已驳回'" type="text" @click="handleViewDetail(scope.row)">查看详情</el-button>
            <el-button v-if="scope.row.reportStatus === '已驳回'" type="text" @click="handleEditReport(scope.row)" style="color: #409EFF;">再次提交</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleMyReportSizeChange"
          @current-change="handleMyReportCurrentChange"
          :current-page="myReportPagination.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="myReportPagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="myReportPagination.total">
        </el-pagination>
      </div>
    </div>

    <!-- 填报审批内容 -->
    <div v-if="activeTab === 'reportApproval'" class="tab-content">
      <!-- 搜索筛选区域 -->
      <div class="filter-section">
        <div class="filter-row">
          <el-date-picker
            v-model="approvalFilters.timeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            class="date-picker-input">
          </el-date-picker>
          
          <el-input v-model="approvalFilters.userName" placeholder="姓名" class="filter-item"></el-input>
          
          <el-button type="primary" plain @click="handleApprovalSearch" class="filter-button">查询</el-button>
          <el-button plain @click="handleApprovalReset" class="filter-button">重置</el-button>
        </div>
      </div>

      <!-- 数据表格 -->
      <el-table :data="approvalData" border stripe style="width: 100%">
        <el-table-column prop="formName" label="填报模版名称" width="150" align="center"></el-table-column>
        <el-table-column prop="name" label="填报人" width="100" align="center"></el-table-column>
        <el-table-column prop="department" label="所在部门" width="120" align="center"></el-table-column>
        <el-table-column prop="team" label="所在班组" width="120" align="center"></el-table-column>
        <el-table-column prop="fillTypeName" label="填报类型" width="100" align="center"></el-table-column>
        <el-table-column prop="healthStatus" label="健康评级" width="100" align="center">
          <template slot-scope="scope">
            <span :class="{ 'status-normal': scope.row.healthStatus === '正常' }">
              {{ scope.row.healthStatus }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="measureDetail" label="排查情况" min-width="180" align="center"></el-table-column>
        <el-table-column prop="controlMeasure" label="管控措施" min-width="180" align="center"></el-table-column>
        <el-table-column prop="healthScore" label="健康评分" width="100" align="center"></el-table-column>
        <el-table-column prop="approvalStatus" label="填报状态" width="100" align="center">
          <template slot-scope="scope">
            <span :class="getStatusClass(scope.row.approvalStatus)">
              {{ scope.row.approvalStatus }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="reportTime" label="填报时间" width="180" align="center"></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.approvalStatus === '待审批'" type="text" @click="handleApprove(scope.row)">审批</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleApprovalSizeChange"
          @current-change="handleApprovalCurrentChange"
          :current-page="approvalPagination.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="approvalPagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="approvalPagination.total">
        </el-pagination>
      </div>
    </div>

    <!-- 健康填报详情弹窗 -->
    <el-dialog
      title="每日健康填报详情"
      :visible.sync="detailDialogVisible"
      width="50%"
      :before-close="handleCloseDetailDialog"
      class="health-detail-dialog">
      <div class="detail-content">
        <h3 class="section-title">基本信息</h3>
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">所在班组</span>
            <span class="detail-value">{{ currentDetail.team || currentDetail.className || '' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">姓名</span>
            <span class="detail-value">{{ currentDetail.name || currentDetail.userName || '' }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">填报方式</span>
            <span class="detail-value">{{ currentDetail.fillTypeName || (currentDetail.fillType === 2 ? '按班组' : '按天') }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">健康评级</span>
            <span class="detail-value">{{ currentDetail.healthStatus || currentDetail.healthRatingName || '' }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">填报时间</span>
            <span class="detail-value">{{ currentDetail.createTime ? formatDateTime(currentDetail.createTime) : '' }}</span>
          </div>
        </div>
        <div class="detail-row" v-if="currentDetail.approvedUserName">
          <div class="detail-item">
            <span class="detail-label">审核人</span>
            <span class="detail-value">{{ currentDetail.approvedUserName || '' }}</span>
          </div>
        </div>
        <div class="detail-row" v-if="currentDetail.approvedTime">
          <div class="detail-item">
            <span class="detail-label">审核时间</span>
            <span class="detail-value">{{ currentDetail.approvedTime ? formatDateTime(currentDetail.approvedTime) : '' }}</span>
          </div>
        </div>

        <h3 class="section-title">健康评分</h3>
        <div class="detail-row">
          <div class="detail-item full-width">
            <span class="detail-value score">{{ (currentDetail.score !== undefined && currentDetail.score !== null) ? currentDetail.score : ((currentDetail.totalScore !== undefined && currentDetail.totalScore !== null) ? currentDetail.totalScore : '-') }}</span>
          </div>
        </div>

        <h3 class="section-title">排查状况 <span class="required">*</span></h3>
        <div v-if="currentDetail.formFields && currentDetail.formFields.length">
          <div class="detail-row" v-for="(field, index) in currentDetail.formFields" :key="'field-'+index">
            <div class="detail-item full-width">
              <span class="detail-label">{{ field.formFieldName }}</span>
              <span class="detail-value">
                <!-- 数字类型字段 -->
                <template v-if="field.fieldType === 1">
                  {{ field.formFieldOptionValue || field.optionValue || field.value || '-' }}
                </template>
                
                <!-- 选择类型字段 (type = 2, 单选) -->
                <template v-else-if="field.fieldType === 2">
                  <span>
                    {{ field.optionName || 
                       (field.selectedOption ? field.selectedOption.name : '') ||
                       (field.optionId && field.options ? 
                         (field.options.find(opt => opt.id == field.optionId) || {}).name : '') ||
                       '-' }}
                  </span>
                </template>
                
                <!-- 其他类型字段 -->
                <template v-else>
                  {{ field.formFieldOptionValue || field.optionName || field.optionValue || field.value || '-' }}
                </template>
              </span>
        </div>
          </div>
        </div>
        <div v-else>
        <div class="detail-row">
          <div class="detail-item full-width">
              <span class="detail-value">{{ currentDetail.measureDetail || '暂无数据' }}</span>
            </div>
          </div>
        </div>

        <h3 class="section-title">管控措施 <span class="required">*</span></h3>
        <div v-if="currentDetail.formMeasures && currentDetail.formMeasures.length">
          <div class="detail-row" v-for="(measure, index) in currentDetail.formMeasures" :key="'measure-'+index">
          <div class="detail-item full-width">
              <span class="detail-value">{{ measure.measureName }}</span>
          </div>
        </div>
          
          <div class="detail-row" v-if="currentDetail.otherMeasure">
            <div class="detail-item full-width">
              <div class="detail-column">
                <span class="detail-label-top">其他管控措施</span>
                <div class="detail-textarea">{{ currentDetail.otherMeasure }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="currentDetail.otherMeasure">
          <div class="detail-row">
            <div class="detail-item full-width">
              <div class="detail-column">
                <span class="detail-label-top">其他管控措施</span>
                <div class="detail-textarea">{{ currentDetail.otherMeasure }}</div>
              </div>
          </div>
        </div>
        </div>
        <div v-else>
        <div class="detail-row">
          <div class="detail-item full-width">
              <span class="detail-value">暂无数据</span>
            </div>
          </div>
        </div>

        <h3 class="section-title">填报流程</h3>
        <div class="process-timeline">
          <div class="process-item">
            <div class="process-time">{{ currentDetail.createTime ? formatDateTime(currentDetail.createTime) : '' }}</div>
            <div class="process-user">{{ currentDetail.name || currentDetail.userName || '' }}</div>
            <div class="process-action">提交</div>
          </div>
          <div class="process-item" v-if="currentDetail.approvedTime">
            <div class="process-time">{{ formatDateTime(currentDetail.approvedTime) }}</div>
            <div class="process-user">{{ currentDetail.approvedUserName || '' }}</div>
            <div class="process-action">{{ currentDetail.status === 2 ? '审批通过' : '审批驳回' }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 今日健康填报弹窗 -->
    <el-dialog
      :title="selectedFormName || '每日健康填报'"
      :visible.sync="reportDialogVisible"
      width="65%"
      :before-close="handleCloseReportDialog"
      class="report-dialog"
      :close-on-click-modal="false">
      <div class="report-content">
        <h3 class="section-title">基本信息</h3>
        <div class="report-row">
          <div class="report-item">
            <span class="report-label">所在班组</span>
            <span class="report-value">{{ reportForm.team }}</span>
          </div>
          <div class="report-item">
            <span class="report-label">姓名</span>
            <span class="report-value">{{ reportForm.name }}</span>
          </div>
        </div>
        <div class="report-row">
          <div class="report-item">
            <span class="report-label">填报方式</span>
            <span class="report-value">按{{ selectedFormName ? (selectedFormName.includes('班组') ? '班组' : '天') : '天' }}</span>
          </div>
          <div class="report-item">
            <span class="report-label">健康评级</span>
            <span class="report-value">{{ reportForm.healthStatus }}</span>
          </div>
        </div>

        <h3 class="section-title">排查状况 <span class="required">*</span></h3>
        <div v-if="reportForm.formFields && reportForm.formFields.length > 0">
          <!-- 动态渲染表单字段 -->
          <div class="report-row" v-for="(field, index) in reportForm.formFields" :key="'field-'+field.formFieldId+'-'+index">
            <div class="report-item" :class="{ 'full-width': !field.options || field.options.length === 0 }">
              <span class="report-label">{{ field.formFieldName }}</span>
            <span class="report-value">
                <!-- 数字输入框类型 (类型为1) -->
                <el-input 
                  v-if="field.fieldType === 1" 
                  v-model.number="field.value" 
                  :placeholder="'请输入'"
                  @input="validateNumber(field)"
                  :disabled="false"
                  :readonly="false">
                </el-input>
                
                <!-- 选择类型 (类型为2) -->
                <template v-else-if="field.fieldType === 2">
                  <div v-if="field.options && field.options.length > 0">
                    <el-radio-group v-model="field.value" :disabled="false">
                      <el-radio 
                        v-for="(option, optionIndex) in field.options" 
                        :key="'radio-'+option.id+'-'+optionIndex" 
                        :label="option.id"
                        :disabled="false">{{ option.optionName }}</el-radio>
                    </el-radio-group>
                  </div>
                  <div v-else>
                    <p>该字段没有可选选项</p>
                  </div>
                </template>
                
                <!-- 一般输入框类型 (无选项的字段) -->
                <el-input 
                  v-else-if="!field.options || field.options.length === 0" 
                  v-model="field.value" 
                  :placeholder="'请输入' + field.formFieldName"
                  :disabled="false"
                  :readonly="false">
                </el-input>
                
                <!-- 选择类型 -->
                <el-select 
                  v-else-if="field.fieldType === 'select'" 
                  v-model="field.value" 
                  :placeholder="'请选择' + field.formFieldName"
                  style="width: 100%"
                  :disabled="false">
                  <el-option 
                    v-for="(option, optionIndex) in field.options" 
                    :key="'option-'+option.id+'-'+optionIndex" 
                    :label="option.name" 
                    :value="option.id">
                  </el-option>
                </el-select>
                
                <!-- 单选类型 -->
                <el-radio-group 
                  v-else-if="field.fieldType === 'radio' || !field.fieldType || field.fieldType === 'unknown'" 
                  v-model="field.value"
                  :disabled="false">
                  <el-radio 
                    v-for="(option, optionIndex) in field.options" 
                    :key="'radio-'+option.id+'-'+optionIndex" 
                    :label="option.id"
                    :disabled="false">{{ option.name }}</el-radio>
                </el-radio-group>
                
                <!-- 多选类型 -->
                <el-checkbox-group 
                  v-else-if="field.fieldType === 'checkbox'" 
                  v-model="field.values"
                  :disabled="false">
                  <el-checkbox 
                    v-for="(option, optionIndex) in field.options" 
                    :key="'checkbox-'+option.id+'-'+optionIndex" 
                    :label="option.id"
                    :disabled="false">{{ option.name }}</el-checkbox>
                </el-checkbox-group>
                
                <!-- 默认显示字段类型 -->
                <div v-else>
                  <p>{{ field.fieldType || '未知' }}类型字段 (type: {{ field.fieldType }})</p>
                  <p>选项数量: {{ field.options ? field.options.length : 0 }}</p>
                  <p v-if="field.options && field.options.length > 0">
                    选项列表: 
                    <span v-for="(opt, oi) in field.options" :key="'opt-name-'+oi">
                      {{ opt.name || '未命名' }}{{ oi < field.options.length - 1 ? ', ' : '' }}
            </span>
                  </p>
          </div>
            </span>
          </div>
        </div>
        </div>
        <div v-else class="report-row">
          <div class="report-item full-width">
            <span class="report-value">暂无排查项</span>
          </div>
        </div>

        <h3 class="section-title">管控措施 <span class="required">*</span></h3>
        <div v-if="reportForm.formMeasures && reportForm.formMeasures.length > 0">
        <div class="report-row">
          <div class="report-item full-width">
              <div class="measure-list">
                <div class="measure-item" v-for="(measure, index) in reportForm.formMeasures" :key="'measure-'+measure.id+'-'+index">
                  <el-checkbox 
                    v-model="measure.checked" 
                    @change="(val) => handleMeasureChange(measure, val)"
                    :disabled="false">
                    {{ measure.measureName }}
                  </el-checkbox>
              </div>
              </div>
              </div>
          </div>
        </div>
        <div v-else class="report-row">
          <div class="report-item full-width">
            <span class="report-value">暂无管控措施</span>
          </div>
        </div>
        <div class="report-row">
          <div class="report-item full-width">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入其他管控措施"
              v-model="reportForm.otherMeasure"
              :disabled="false"
              :readonly="false">
            </el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reportDialogVisible = false">取消</el-button>
        <el-button 
          type="primary" 
          @click="submitReport" 
          :loading="loading.submit" 
          :disabled="isSubmitting">
          {{ isEditMode ? '再次提交' : '提交' }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 选择健康表单弹窗 -->
    <el-dialog
      title="选择填报表单"
      :visible.sync="selectFormDialogVisible"
      width="70%"
      :before-close="handleCloseSelectFormDialog"
      class="select-form-dialog">
      <div class="select-form-content">
        <div v-if="healthForms.length > 0" class="form-cards-container">
          <el-card 
            v-for="form in healthForms" 
            :key="form.id" 
            shadow="hover" 
            class="form-card"
            @click.native="handleSelectForm(form)">
            <div class="form-card-header">
              <span class="form-name">{{ form.name }}</span>
            </div>
            <div class="form-card-content">
              <div class="form-item">
                <span class="form-label">健康评级:</span>
                <span class="form-value">{{ form.healthRatingName || '未设置' }}</span>
              </div>
              <div class="form-item">
                <span class="form-label">所在班组:</span>
                <span class="form-value">{{ form.className || '未设置' }}</span>
              </div>
              <div class="form-item">
                <span class="form-label">填报类型:</span>
                <span class="form-value">{{ form.fillTypeName || (form.fillType === 1 ? '按天' : '按班组') }}</span>
              </div>
              <div class="form-item">
                <span class="form-label">排查项:</span>
                <span class="form-value">{{ form.fieldCount || 0 }}项</span>
              </div>
              <div class="form-item">
                <span class="form-label">管控措施:</span>
                <span class="form-value">{{ form.measureCount || 0 }}项</span>
              </div>
            </div>
          </el-card>
        </div>
        <div v-else class="empty-state">
          <i class="el-icon-document"></i>
          <p>暂无可填报的表单</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectFormDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <!-- 健康填报审批弹窗 -->
    <el-dialog
      title="每日健康填报审批"
      :visible.sync="approvalDialogVisible"
      width="50%"
      :before-close="handleCloseApprovalDialog"
      class="health-detail-dialog">
      <div class="detail-content">
        <h3 class="section-title">基本信息</h3>
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">所在班组</span>
            <span class="detail-value">{{ currentApproval.team || currentApproval.className || '' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">姓名</span>
            <span class="detail-value">{{ currentApproval.name || currentApproval.userName || '' }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">填报方式</span>
            <span class="detail-value">{{ currentApproval.fillTypeName || (currentApproval.fillType === 2 ? '按班组' : '按天') }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">健康评级</span>
            <span class="detail-value">{{ currentApproval.healthStatus || currentApproval.healthRatingName || '' }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">填报时间</span>
            <span class="detail-value">{{ currentApproval.createTime ? formatDateTime(currentApproval.createTime) : '' }}</span>
          </div>
        </div>

        <h3 class="section-title">健康评分</h3>
        <div class="detail-row">
          <div class="detail-item full-width">
            <span class="detail-value score">{{ (currentApproval.score !== undefined && currentApproval.score !== null) ? currentApproval.score : ((currentApproval.totalScore !== undefined && currentApproval.totalScore !== null) ? currentApproval.totalScore : '-') }}</span>
          </div>
        </div>

        <h3 class="section-title">排查状况 <span class="required">*</span></h3>
        <div v-if="currentApproval.formFields && currentApproval.formFields.length">
          <div class="detail-row" v-for="(field, index) in currentApproval.formFields" :key="'field-'+index">
            <div class="detail-item full-width">
              <span class="detail-label">{{ field.formFieldName }}</span>
              <span class="detail-value">
                <!-- 数字类型字段 -->
                <template v-if="field.fieldType === 1">
                  {{ field.formFieldOptionValue || field.optionValue || field.value || '-' }}
                </template>
                
                <!-- 选择类型字段 (type = 2, 单选) -->
                <template v-else-if="field.fieldType === 2">
                  <span>
                    {{ field.optionName || 
                       (field.selectedOption ? field.selectedOption.name : '') ||
                       (field.optionId && field.options ? 
                         (field.options.find(opt => opt.id == field.optionId) || {}).name : '') ||
                       '-' }}
                  </span>
                </template>
                
                <!-- 其他类型字段 -->
                <template v-else>
                  {{ field.formFieldOptionValue || field.optionName || field.optionValue || field.value || '-' }}
                </template>
              </span>
          </div>
          </div>
        </div>
        <div v-else>
          <div class="detail-row">
            <div class="detail-item full-width">
              <span class="detail-value">{{ currentApproval.measureDetail || '暂无数据' }}</span>
            </div>
          </div>
        </div>

        <h3 class="section-title">管控措施 <span class="required">*</span></h3>
        <div v-if="currentApproval.formMeasures && currentApproval.formMeasures.length">
          <div class="detail-row" v-for="(measure, index) in currentApproval.formMeasures" :key="'measure-'+index">
            <div class="detail-item full-width">
              <span class="detail-value">{{ measure.measureName }}</span>
            </div>
          </div>
          
          <div class="detail-row" v-if="currentApproval.otherMeasure">
            <div class="detail-item full-width">
              <div class="detail-column">
                <span class="detail-label-top">其他管控措施</span>
                <div class="detail-textarea">{{ currentApproval.otherMeasure }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="currentApproval.otherMeasure">
          <div class="detail-row">
            <div class="detail-item full-width">
              <div class="detail-column">
                <span class="detail-label-top">其他管控措施</span>
                <div class="detail-textarea">{{ currentApproval.otherMeasure }}</div>
              </div>
          </div>
        </div>
        </div>
        <div v-else>
          <div class="detail-row">
            <div class="detail-item full-width">
              <span class="detail-value">暂无数据</span>
            </div>
          </div>
        </div>

        <h3 class="section-title">填报流程</h3>
        <div class="process-timeline">
          <div class="process-item">
            <div class="process-time">{{ currentApproval.createTime ? formatDateTime(currentApproval.createTime) : '' }}</div>
            <div class="process-user">{{ currentApproval.name || currentApproval.userName || '' }}</div>
            <div class="process-action">提交</div>
          </div>
        </div>

        <h3 class="section-title">审批结果</h3>
        <div class="detail-row">
          <div class="detail-item full-width">
            <span class="detail-label">是否通过</span>
            <span class="detail-value">
              <el-radio-group v-model="approvalForm.result">
                <el-radio label="通过">通过</el-radio>
                <el-radio label="驳回">驳回</el-radio>
              </el-radio-group>
            </span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="approvalDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitApproval">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getMyReports, getPendingApproval, getHealthFormUserDetail, initHealthFormUser, submitHealthFormUser, approveHealthFormUser, resubmitHealthFormUser, getDailyReportStatus } from '@/api/health-form-user'
import { getAllHealthForms, getAvailableForms } from '@/api/health-form'

export default {
  name: 'DailyReport',
  data() {
    return {
      activeTab: 'myReport',
      detailDialogVisible: false,
      reportDialogVisible: false,
      approvalDialogVisible: false,
      currentDetail: {},
      currentApproval: {},
      healthForms: [], // 健康表单列表
      selectedFormId: null, // 选中的表单ID
      
      // 防重复提交变量
      isSubmitting: false,
      submitTimestamp: 0,
      
      // 今日健康填报状态
      dailyReportStatus: {
        completed: false,     // 是否已完成填报
        pendingCount: 0,      // 待填报数量
        loading: false        // 加载状态
      },
      
      // 审批表单数据
      approvalForm: {
        result: ''
      },
      
      // 填报表单数据
      reportForm: {
        executionTime: this.formatDate(new Date()),
        team: '生产一组',
        shift: '早班',
        name: '陈明宇',
        healthStatus: '正常',
        bloodPressure: '',
        temperature: '',
        coldSymptoms: '无',
        controlMeasures: [],
        otherMeasure: '',
        formId: null,
        formFields: [],
        formMeasures: [],
        classId: null
      },
      
      // 我的填报相关数据
      myReportFilters: {
        timeRange: '',
        status: '',
        pageNum: 1,
        pageSize: 10,
        onlySelfReports: true
      },
      myReportData: [],
      myReportPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      
      // 填报审批相关数据
      approvalFilters: {
        userName: '',
        approvalStatus: '',
        timeRange: '',
        pageNum: 1,
        pageSize: 10,
        onlySelfApproval: true
      },
      approvalData: [],
      approvalPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: {
        myReport: false,
        approval: false,
        detail: false,
        submit: false
      },
      selectFormDialogVisible: false,
      selectedMeasures: [],
      selectedFormName: '',
      isEditMode: false // 是否是编辑模式
    }
  },
  created() {
    // 从路由参数获取activeTab，如果存在则使用，否则使用默认值'myReport'
    const { activeTab } = this.$route.query;
    if (activeTab && (activeTab === 'myReport' || activeTab === 'reportApproval')) {
      this.activeTab = activeTab;
    }
    
    this.fetchHealthForms();
    
    // 根据当前活动标签页加载相应数据
    if (this.activeTab === 'reportApproval') {
      this.fetchPendingApproval();
    } else {
      this.fetchMyReports();
    }
    
    // 获取当日填报状态
    this.fetchDailyReportStatus();
  },
  watch: {
    '$route.query.activeTab': {
      handler(newVal) {
        if (newVal) {
          this.activeTab = newVal;
          console.log('路由参数变化，更新活动标签页:', this.activeTab);
        }
      },
      immediate: true
    },
    activeTab(newVal) {
      if (newVal === 'reportApproval') {
        this.fetchPendingApproval()
      } else if (newVal === 'myReport') {
        this.fetchMyReports()
      }
    }
  },
  methods: {
    // 获取健康表单列表
    async fetchHealthForms() {
      try {
        const res = await getAllHealthForms()
        if (res.data && Array.isArray(res.data)) {
          this.healthForms = res.data
          if (this.healthForms.length > 0) {
            this.selectedFormId = this.healthForms[0].id
          }
        }
      } catch (error) {
        console.error('获取健康表单列表失败', error)
        this.$message.error('获取健康表单列表失败')
      }
    },
    
    // 重置提交状态
    resetSubmitStatus() {
      console.log('重置提交状态');
      this.isSubmitting = false;
      this.submitTimestamp = 0;
    },
    
    // 获取当前用户可填报的健康表单
    async fetchAvailableForms() {
      try {
        const res = await getAvailableForms()
        if (res.data && Array.isArray(res.data)) {
          this.healthForms = res.data
          if (this.healthForms.length > 0) {
            this.selectedFormId = this.healthForms[0].id
            this.selectFormDialogVisible = true
          } else {
            this.$message.warning('当前没有可填报的健康表单')
          }
        } else {
          this.$message.warning('当前没有可填报的健康表单')
        }
      } catch (error) {
        console.error('获取可填报表单失败', error)
        this.$message.error('获取可填报表单失败')
      }
    },
    
    // 获取我的填报数据
    async fetchMyReports() {
      if (this.loading.myReport) return
      this.loading.myReport = true
      
      try {
        // 创建一个新的参数对象，避免直接修改myReportFilters
        const params = { ...this.myReportFilters }
        
        // 处理时间范围
        if (params.timeRange && Array.isArray(params.timeRange) && params.timeRange.length === 2) {
          params.createTimeStart = params.timeRange[0]
          params.createTimeEnd = params.timeRange[1]
        } else if (typeof params.timeRange === 'string' && params.timeRange.includes(' - ')) {
          const [start, end] = params.timeRange.split(' - ')
          params.createTimeStart = start
          params.createTimeEnd = end
        }
        
          // 删除timeRange参数，避免发送到后端
          delete params.timeRange
        
        // 添加必须的参数
        params.onlySelfReports = true
        
        const res = await getMyReports(params)
        if (res.data && res.data.list) {
          // 处理返回的数据
          this.myReportData = res.data.list.map((item, index) => {
            let statusText = '未知'
            if (item.status === 1) {
              statusText = '待审批'
            } else if (item.status === 2) {
              statusText = '已通过'
            } else if (item.status === 9) {
              statusText = '已驳回'
            }
            // 格式化时间
            const reportTime = item.createTime ? this.formatDateTime(item.createTime) : '-'
            // 获取填报类型
            let fillTypeName = '-'
            if (item.fillType === 1) {
              fillTypeName = '按天'
            } else if (item.fillType === 2) {
              fillTypeName = '按班组'
            } else {
              fillTypeName = item.fillTypeName || '-'
            }
            return {
              ...item,
              measureDetail: item.fieldContent || '-',
              controlMeasure: item.measureContent || '-',
              formName: item.formName || '-',
              name: item.userName,
              department: item.departmentName || '-',
              team: item.className || item.teamName || '-',
              fillTypeName,
              healthStatus: item.healthRatingName || '-',
              healthScore: item.score || item.totalScore || '-',
              reportStatus: statusText,
              reportTime
            }
          })
          
          this.myReportPagination.total = res.data.total || 0
          this.myReportPagination.currentPage = res.data.pageNum || 1
          this.myReportPagination.pageSize = res.data.pageSize || 10
        } else {
          this.myReportData = []
          this.myReportPagination.total = 0
        }
      } catch (error) {
        console.error('获取我的填报数据失败', error)
        this.$message.error('获取我的填报数据失败')
        this.myReportData = []
      } finally {
        this.loading.myReport = false
      }
    },
    
    // 获取待审批数据
    async fetchPendingApproval() {
      if (this.loading.approval) return
      this.loading.approval = true
      
      try {
        // 构造请求参数
        const params = { ...this.approvalFilters }
        
        // 处理时间范围
        if (params.timeRange && Array.isArray(params.timeRange) && params.timeRange.length === 2) {
          params.createTimeStart = params.timeRange[0]
          params.createTimeEnd = params.timeRange[1]
        } else if (typeof params.timeRange === 'string' && params.timeRange.includes(' - ')) {
          const [start, end] = params.timeRange.split(' - ')
          params.createTimeStart = start
          params.createTimeEnd = end
        }
        
          // 删除timeRange参数，避免发送到后端
          delete params.timeRange
        
        // 处理状态
        if (params.approvalStatus === 'pending') {
          params.status = 1 // 待审核
        } else if (params.approvalStatus === 'approved') {
          params.status = 2 // 已审核通过
        } else {
          params.status = ''
        }
        // 删除approvalStatus参数，避免发送到后端
        delete params.approvalStatus
        
        console.log('待审批查询参数:', params)
        
        const res = await getPendingApproval(params)
        if (res.data && res.data.list) {
          // 处理返回的数据
          this.approvalData = res.data.list.map((item, index) => {
            let statusText = '未知'
            if (item.status === 1) {
              statusText = '待审批'
            } else if (item.status === 2) {
              statusText = '已审批'
            } else if (item.status === 9) {
              statusText = '已驳回'
            }
            
            // 格式化时间
            const reportTime = item.createTime ? this.formatDateTime(item.createTime) : '-'
            
            // 使用fieldContent作为排查情况
            const measureDetail = item.fieldContent || '-'
            
            // 使用measureContent作为管控措施
            const controlMeasure = item.measureContent || '-'
            
            // 获取填报类型
            let fillTypeName = '-'
            if (item.fillType === 1) {
              fillTypeName = '按天'
            } else if (item.fillType === 2) {
              fillTypeName = '按班组'
            } else {
              fillTypeName = item.fillTypeName || '-'
            }
            
            return {
              id: item.id,
              formName: item.formName || '-',
              name: item.userName || item.name,
              department: item.departmentName || '-',
              team: item.className || item.teamName || '-', // 优先使用className
              fillTypeName,
              healthStatus: item.healthRatingName || '-',
              measureDetail,
              controlMeasure,
              healthScore: item.score || item.totalScore || '-', // 优先使用score
              approvalStatus: statusText,
              reportTime,
              // 保存原始数据用于详情展示
              ...item
            }
          })
          
          this.approvalPagination.total = res.data.total || 0
          this.approvalPagination.currentPage = res.data.pageNum || 1
          this.approvalPagination.pageSize = res.data.pageSize || 10
        } else {
          this.approvalData = []
          this.approvalPagination.total = 0
        }
      } catch (error) {
        console.error('获取待审批数据失败', error)
        this.$message.error('获取待审批数据失败')
        this.approvalData = []
      } finally {
        this.loading.approval = false
      }
    },
    
    // 查看详情
    async handleViewDetail(row) {
      if (this.loading.detail) return
      this.loading.detail = true
      
      try {
        const res = await getHealthFormUserDetail(row.id)
        if (res.data) {
          this.currentDetail = res.data
          this.detailDialogVisible = true
        }
      } catch (error) {
        console.error('获取健康填报详情失败', error)
        this.$message.error('获取健康填报详情失败')
      } finally {
        this.loading.detail = false
      }
    },
    
    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    
    // 格式化日期时间为yyyy-MM-dd HH:mm:ss
    formatDateTime(dateTime) {
      if (!dateTime) return '-'
      
      // 如果是时间戳（数字），转换为Date对象
      let date = dateTime
      if (typeof dateTime === 'number') {
        date = new Date(dateTime)
      } else if (typeof dateTime === 'string' && !isNaN(Number(dateTime))) {
        date = new Date(Number(dateTime))
      } else if (typeof dateTime === 'string') {
        date = new Date(dateTime)
      }
      
      if (!(date instanceof Date) || isNaN(date)) {
        return dateTime.toString()
      }
      
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    
    // 切换标签页
    switchTab(tab) {
      this.activeTab = tab;
      
      // 更新路由参数，以便在刷新页面时保持选中的标签页
      this.$router.push({
        query: {
          ...this.$route.query,
          activeTab: tab
        }
      });
      
      // 根据当前活动标签页加载相应数据
      if (tab === 'reportApproval') {
        this.fetchPendingApproval();
      } else {
        this.fetchMyReports();
      }
    },
    
    // 获取状态样式类
    getStatusClass(status) {
      switch(status) {
        case '已填报':
        case '已审批':
          return 'status-reported';
        case '待审批':
          return 'status-pending';
        default:
          return '';
      }
    },
    
    // 我的填报 - 搜索
    handleMyReportSearch() {
      this.myReportPagination.currentPage = 1
      this.fetchMyReports()
    },
    
    // 我的填报 - 重置搜索条件
    handleMyReportReset() {
      this.myReportFilters = {
        timeRange: '',
        status: '',
        pageNum: 1,
        pageSize: 10,
        onlySelfReports: true
      };
      this.fetchMyReports()
    },
    
    // 填报审批 - 搜索
    handleApprovalSearch() {
      this.approvalPagination.currentPage = 1
      this.fetchPendingApproval()
    },
    
    // 填报审批 - 重置搜索条件
    handleApprovalReset() {
      this.approvalFilters = {
        userName: '',
        approvalStatus: '',
        timeRange: '',
        pageNum: 1,
        pageSize: 10,
        onlySelfApproval: true
      };
      this.fetchPendingApproval()
    },
    
    // 今日健康填报
    handleDailyReport() {
      console.log('点击了今日健康填报按钮');
      // 重置相关数据
      this.selectedFormName = '';
      this.selectedMeasures = [];
      this.reportForm = {
        executionTime: this.formatDate(new Date()),
        team: '生产一组',
        shift: '早班',
        name: '陈明宇',
        healthStatus: '正常',
        formId: null,
        formFields: [],
        formMeasures: [],
        otherMeasure: '',
        classId: null
      };
      
      // 重置提交状态
      this.resetSubmitStatus();
      
      // 获取当前用户可填报的表单
      this.fetchAvailableForms();
    },
    
    // 关闭填报弹窗
    handleCloseReportDialog() {
      this.reportDialogVisible = false;
      this.isEditMode = false; // 重置编辑模式标记
      this.resetSubmitStatus(); // 重置提交状态
    },
    
    // 提交填报
    async submitReport() {
      console.log('点击了提交按钮，当前模式:', this.isEditMode ? '再次提交(修改记录)' : '新建提交');
      
      // 防重复提交检查
      const now = Date.now();
      if (this.isSubmitting && (now - this.submitTimestamp < 3000)) {
        this.$message.warning('请勿重复提交');
        return;
      }
      
      // 验证检查前先看一下字段ID情况
      if (this.reportForm.formFields && this.reportForm.formFields.length > 0) {
        console.log('提交前检查字段ID情况:');
        this.reportForm.formFields.forEach((field, index) => {
          console.log(`字段[${index}] ${field.formFieldName} - id:${field.id}, fieldId:${field.fieldId}, formFieldId:${field.formFieldId}`);
        });
      }
      
      if (this.reportForm.formMeasures && this.reportForm.formMeasures.length > 0) {
        console.log('提交前检查管控措施ID情况:');
        this.reportForm.formMeasures.forEach((measure, index) => {
          console.log(`措施[${index}] ${measure.measureName} - id:${measure.id}, measureId:${measure.measureId}`);
        });
      }
      
      // 验证是否选择了表单
      if (!this.reportForm.formId) {
        this.$message.error('请选择健康表单');
        return;
      }
      
      // 验证排查项是否填写完整
      if (this.reportForm.formFields && this.reportForm.formFields.length > 0) {
        for (const field of this.reportForm.formFields) {
          console.log(`验证字段: ${field.formFieldName}, 类型: ${field.fieldType}, 当前值:`, field.fieldType === 2 ? field.value : (field.value || "空"));
          
          // 数字类型字段验证
          if (field.fieldType === 1) {
            if (field.value === '' || field.value === null || field.value === undefined || isNaN(Number(field.value))) {
              this.$message.error(`请为${field.formFieldName}输入有效的数字`);
              return;
            }
            // 确保值为数字类型
            field.value = Number(field.value);
          } 
          // 单选类型字段验证
          else if (field.fieldType === 2) {
            if (!field.value && field.value !== 0) {
              this.$message.error(`请为${field.formFieldName}选择一项`);
              return;
            }
          }
          // 多选类型字段验证
          else if (field.fieldType === 'checkbox') {
            if (!field.values || !field.values.length) {
              this.$message.error(`请为${field.formFieldName}至少选择一项`);
              return;
            }
          }
          // 其他类型字段验证
          else if (!field.value && (!field.values || !field.values.length)) {
            this.$message.error(`请填写${field.formFieldName}`);
            return;
          }
        }
      }
      
      // 验证是否选择了管控措施
      if (this.reportForm.formMeasures && this.reportForm.formMeasures.length > 0) {
        // 检查是否至少有一个措施被选中
        const hasSelectedMeasure = this.reportForm.formMeasures.some(measure => measure.checked);
        
        if (!hasSelectedMeasure && !this.reportForm.otherMeasure) {
          this.$message.error('请至少选择一项管控措施或填写其他管控措施');
          return;
        }
      }
      
      // 设置提交状态，防止重复提交
      this.isSubmitting = true;
      this.submitTimestamp = now;
      
      if (this.loading.submit) return;
      this.loading.submit = true;
      
      try {
        console.log('提交前的formFields:', this.reportForm.formFields);
        console.log('提交前的selectedMeasures:', this.selectedMeasures);
        
        // 构建提交数据
        const submitData = {
          formId: this.reportForm.formId,
          // 处理表单字段数据
          formFields: this.reportForm.formFields.map(field => {
            // 数字类型字段处理
            if (field.fieldType === 1) {
              return {
                formFieldId: field.id || field.formFieldId || field.fieldId,
                formFieldOptionValue: field.value.toString() // 确保数字转为字符串
              };
            }
            // 单选类型字段处理 (type = 2)
            else if (field.fieldType === 2) {
              return {
                formFieldId: field.id || field.formFieldId || field.fieldId,
                formFieldOptionId: field.value
              };
            }
            // 多选处理
            else if (field.fieldType === 'checkbox' && field.values) {
              return {
                formFieldId: field.id || field.formFieldId || field.fieldId,
                formFieldOptionIds: field.values
              };
            } 
            // 其他单选或输入框处理
            else {
              return {
                formFieldId: field.id || field.formFieldId || field.fieldId,
                formFieldOptionId: field.value,
                formFieldOptionValue: !field.options || field.options.length === 0 ? field.value : undefined
              };
            }
          })
        };
        
        // 编辑模式(再次提交)和新建模式使用不同的API
        if (this.isEditMode && this.reportForm.id) {
          // 再次提交模式 - 不需要在submitData中添加id，而是使用专门的resubmitAPI
          console.log(`再次提交模式：使用resubmit接口修改原有记录 ID=${this.reportForm.id}`);
          
          // 添加班组ID(如果是按班组填报)
          if (this.reportForm.classId) {
            submitData.classId = this.reportForm.classId;
            console.log(`添加班组ID到提交数据: ${submitData.classId}`);
          }
          
          // 添加管控措施数据(如果存在)
          if (this.reportForm.formMeasures && this.reportForm.formMeasures.length > 0) {
            console.log('处理管控措施提交数据...');
            
            // 获取选中的管控措施
            const selectedMeasures = this.reportForm.formMeasures.filter(measure => measure.checked);
            
            console.log('选中的管控措施:', selectedMeasures);
            
            if (selectedMeasures.length > 0) {
              submitData.formMeasures = selectedMeasures.map(measure => {
                // 优先使用formMeasureId
                const measureId = measure.formMeasureId || measure.id || measure.measureId;
                console.log(`提交管控措施: ${measure.measureName}, ID: ${measureId}`);
                return {
                  formMeasureId: measureId
                };
              });
            }
          }
          
          // 添加其他管控措施
          if (this.reportForm.otherMeasure) {
            submitData.otherMeasure = this.reportForm.otherMeasure;
          }
          
          console.log('提交的完整数据:', JSON.stringify(submitData, null, 2));
          
          // 调用resubmit API保存数据
          const submitResponse = await resubmitHealthFormUser(this.reportForm.id, submitData);
          
          console.log('API提交响应:', submitResponse);
          
          if (submitResponse.code === 200) {
            this.$message.success('再次提交成功');
            this.reportDialogVisible = false;
            
            // 重置编辑模式状态
            this.isEditMode = false;
            
            // 重新加载我的填报数据
            this.fetchMyReports();
            
            // 更新当日填报状态
            this.fetchDailyReportStatus();
          } else {
            this.$message.error(submitResponse.message || '再次提交失败');
          }
        } else {
          // 新建提交模式
          console.log('新建提交模式：创建新记录');
        
        // 添加班组ID(如果是按班组填报)
        if (this.reportForm.classId) {
          submitData.classId = this.reportForm.classId;
          console.log(`添加班组ID到提交数据: ${submitData.classId}`);
        }
        
        // 添加管控措施数据(如果存在)
        if (this.reportForm.formMeasures && this.reportForm.formMeasures.length > 0) {
          console.log('处理管控措施提交数据...');
          
          // 获取选中的管控措施
          const selectedMeasures = this.reportForm.formMeasures.filter(measure => measure.checked);
          
          console.log('选中的管控措施:', selectedMeasures);
          
          if (selectedMeasures.length > 0) {
            submitData.formMeasures = selectedMeasures.map(measure => {
              // 优先使用formMeasureId
              const measureId = measure.formMeasureId || measure.id || measure.measureId;
              console.log(`提交管控措施: ${measure.measureName}, ID: ${measureId}`);
              return {
                formMeasureId: measureId
              };
            });
          }
        }
        
        // 添加其他管控措施
        if (this.reportForm.otherMeasure) {
          submitData.otherMeasure = this.reportForm.otherMeasure;
        }
        
          console.log('提交的完整数据:', JSON.stringify(submitData, null, 2));
        
        // 调用API保存数据
          const submitResponse = await submitHealthFormUser(submitData);
        
      console.log('API提交响应:', submitResponse);
        
          if (submitResponse.code === 200) {
            this.$message.success('提交成功');
            this.reportDialogVisible = false;
            
            // 重置编辑模式状态
            this.isEditMode = false;
            
            // 重新加载我的填报数据
            this.fetchMyReports();
            
            // 更新当日填报状态
            this.fetchDailyReportStatus();
          } else {
            this.$message.error(submitResponse.message || '提交失败');
          }
        }
      } catch (error) {
        console.error('提交失败', error);
        this.$message.error(this.isEditMode ? '再次提交失败' : '提交失败');
      } finally {
        this.loading.submit = false;
        
        // 延迟重置提交状态，防止快速重复点击
        setTimeout(() => {
          this.isSubmitting = false;
        }, 3000);
      }
    },
    
    // 关闭详情弹窗
    handleCloseDetailDialog() {
      this.detailDialogVisible = false;
    },
    
    // 审批
    async handleApprove(row) {
      if (this.loading.detail) return
      this.loading.detail = true
      
      try {
        const res = await getHealthFormUserDetail(row.id)
        if (res.data) {
          this.currentApproval = res.data
      this.approvalForm.result = '';
          this.approvalDialogVisible = true
        }
      } catch (error) {
        console.error('获取健康填报详情失败', error)
        this.$message.error('获取健康填报详情失败')
      } finally {
        this.loading.detail = false
      }
    },
    
    // 关闭审批弹窗
    handleCloseApprovalDialog() {
      this.approvalDialogVisible = false;
    },
    
    // 提交审批
    async submitApproval() {
      if (!this.approvalForm.result) {
        this.$message.error('请选择审批结果');
        return;
      }
      
      try {
        const status = this.approvalForm.result === '通过' ? 2 : 9
        const res = await approveHealthFormUser(this.currentApproval.id, status)
        
        if (res.success) {
      this.$message.success(`审批${this.approvalForm.result === '通过' ? '通过' : '驳回'}成功`);
      
      // 更新列表数据
          this.fetchPendingApproval()
      this.approvalDialogVisible = false;
        } else {
          this.$message.error(res.message || '审批失败')
        }
      } catch (error) {
        console.error('提交审批失败', error)
        this.$message.error('提交审批失败')
      }
    },
    
    // 我的填报 - 分页大小变化
    handleMyReportSizeChange(size) {
      this.myReportPagination.pageSize = size;
      this.myReportFilters.pageSize = size;
      this.fetchMyReports()
    },
    
    // 我的填报 - 当前页变化
    handleMyReportCurrentChange(page) {
      this.myReportPagination.currentPage = page;
      this.myReportFilters.pageNum = page;
      this.fetchMyReports()
    },
    
    // 填报审批 - 分页大小变化
    handleApprovalSizeChange(size) {
      this.approvalPagination.pageSize = size;
      this.approvalFilters.pageSize = size;
      this.fetchPendingApproval()
    },
    
    // 填报审批 - 当前页变化
    handleApprovalCurrentChange(page) {
      this.approvalPagination.currentPage = page;
      this.approvalFilters.pageNum = page;
      this.fetchPendingApproval()
    },

    // 选择健康表单
    async handleSelectForm(form) {
      console.log('选择了表单:', form);
      // 记录选中的表单ID和名称
      this.reportForm.formId = form.id;
      this.selectedFormName = form.name;
      this.selectFormDialogVisible = false;
      
      // 加载中状态
      this.loading.submit = true;
      
      try {
        console.log('初始化表单数据:', {
          formId: form.id,
          formName: form.name,
          fillType: form.fillType
        });
        
        // 判断是否是按班组填报，如果是则传递班组ID
        let classId = null;
        
        // 根据表单的fillType判断填报类型，2表示按班组填报
        if (form.fillType === 2) {
          // 如果表单中有指定班组，则使用表单中的班组ID
          if (form.classId) {
            classId = form.classId;
            console.log(`使用表单中的班组ID: ${classId}`);
          } else if (form.classList && form.classList.length > 0) {
            // 如果有班组列表，使用第一个班组ID
            classId = form.classList[0].id;
            console.log(`使用班组列表中的第一个班组ID: ${classId}`);
          }
        }
        
        // 获取表单初始化数据，按班组填报时传入班组ID
        const res = await initHealthFormUser(form.id, classId);
        
        console.log('表单初始化API返回数据:', res);
        
        // 检查管控措施数据
        if (res.data && res.data.formMeasures) {
          console.log('初始化时的管控措施数据:', res.data.formMeasures);
          res.data.formMeasures.forEach((measure, index) => {
            console.log(`初始措施[${index}]: ${measure.measureName}, id: ${measure.id}, measureId: ${measure.measureId}`);
          });
        }

        if (res.data) {
          // 使用返回的用户和班组信息
          const formData = res.data;
          
          // 处理每个字段的options，确保正确格式
          if (formData.formFields && formData.formFields.length > 0) {
            formData.formFields.forEach((field, index) => {
              console.log(`处理字段[${index}]: ${field.formFieldName}, 类型: ${field.fieldType}`);
              
              // 确保字段有有效的formFieldId
              if (!field.formFieldId) {
                if (field.id) {
                  field.formFieldId = field.id;
                  console.log(`字段[${index}]使用id(${field.id})作为formFieldId`);
                } else if (field.fieldId) {
                  field.formFieldId = field.fieldId;
                  console.log(`字段[${index}]使用fieldId(${field.fieldId})作为formFieldId`);
                } else {
                  // 使用临时ID确保不为空
                  field.formFieldId = `temp-field-${index}`;
                  console.warn(`警告: 字段缺少ID - ${field.formFieldName || '未命名'}, 使用临时ID: ${field.formFieldId}`);
                }
              }
              
              // 确保id与formFieldId一致
              field.id = field.formFieldId;
              
              // 确保options是数组
              if (!field.options) {
                field.options = [];
              }
              
              // 字段类型处理并初始化相应的值
              if (!field.fieldType) {
                if (field.fieldType === 1) {
                  field.fieldType = 'number';
                  field.value = '';
                } else if (field.fieldType === 2) {
                  field.fieldType = 'radio';
                  field.value = '';
                } else if (field.options && field.options.length > 0) {
                  field.fieldType = field.options.length > 3 ? 'select' : 'radio';
                  field.value = '';
                } else {
                  field.fieldType = 'text';
                  field.value = '';
                }
                console.log(`设置字段类型: ${field.fieldType}`);
              } else {
                // 确保字段有正确的初始化值
                if (field.fieldType === 1) {
                  field.value = '';
                } else if (field.fieldType === 2) {
                  field.value = '';
                } else if (field.fieldType === 'checkbox') {
                  field.values = [];
                } else {
                  field.value = '';
                }
              }
            });
          }
          
          // 确保管控措施有有效的ID
          if (formData.formMeasures && formData.formMeasures.length > 0) {
            formData.formMeasures.forEach((measure, index) => {
              // 确保ID不为空，使用更多可能的属性来获取ID
              if (!measure.formMeasureId) {
                if (measure.id) {
                  measure.formMeasureId = measure.id;
                  console.log(`措施[${index}]使用id(${measure.id})作为formMeasureId`);
                } else if (measure.measureId) {
                  measure.formMeasureId = measure.measureId;
                  console.log(`措施[${index}]使用measureId(${measure.measureId})作为formMeasureId`);
                } else {
                  // 使用临时ID确保不为空
                  measure.formMeasureId = `temp-${index}`;
                  console.warn(`警告: 管控措施缺少ID - ${measure.measureName || '未命名'}, 使用临时ID: ${measure.formMeasureId}`);
                }
              }
              
              // 确保id与formMeasureId一致
              measure.id = measure.formMeasureId;
              
              // 初始化checked属性
              measure.checked = false;
              
              console.log(`初始化措施[${index}]: ${measure.measureName}, formMeasureId: ${measure.formMeasureId}`);
            });
          }
          
          // 重置已选中的措施
          this.selectedMeasures = [];
          
          // 初始化填报表单数据
          this.reportForm = {
            executionTime: this.formatDate(new Date()),
            team: formData.className || '生产一组',
            shift: formData.shiftName || '早班',
            name: formData.userName || '陈明宇',
            healthStatus: formData.healthRatingName || '正常',
            formId: form.id,
            formFields: formData.formFields || [],
            formMeasures: formData.formMeasures || [],
            otherMeasure: '',
            classId: classId
          };
          
          console.log('初始化完成的reportForm:', this.reportForm);
          
          // 打开填报弹窗
          this.reportDialogVisible = true;
          this.loading.submit = false;
          
          // 确保所有表单元素都可以编辑
          this.$nextTick(() => {
            // 输出当前表单状态，检查是否有任何字段被设为只读
            console.log('确保表单可编辑 - 当前表单字段:', this.reportForm.formFields);
            console.log('确保表单可编辑 - 当前管控措施:', this.reportForm.formMeasures);
            
            // 检查并移除任何可能的只读属性
            if (this.reportForm.formFields) {
              this.reportForm.formFields.forEach(field => {
                if (field.readonly === true) {
                  console.log(`移除字段 ${field.formFieldName} 的只读属性`);
                  field.readonly = false;
                }
                if (field.disabled === true) {
                  console.log(`移除字段 ${field.formFieldName} 的禁用属性`);
                  field.disabled = false;
                }
              });
            }
            
            if (this.reportForm.formMeasures) {
              this.reportForm.formMeasures.forEach(measure => {
                if (measure.readonly === true) {
                  console.log(`移除措施 ${measure.measureName} 的只读属性`);
                  measure.readonly = false;
                }
                if (measure.disabled === true) {
                  console.log(`移除措施 ${measure.measureName} 的禁用属性`);
                  measure.disabled = false;
                }
              });
            }
          });
        } else {
          this.$message.error('获取表单初始化数据失败');
        }
      } catch (error) {
        console.error('获取表单初始化数据失败', error);
        this.$message.error('获取表单初始化数据失败');
      } finally {
        this.loading.submit = false;
      }
    },

    // 关闭选择健康表单弹窗
    handleCloseSelectFormDialog() {
      this.selectFormDialogVisible = false;
    },
    
    // 验证输入值必须为数字
    validateNumber(field) {
      console.log('验证数字输入:', field.value);
      
      // 如果输入为空，不做验证
      if (field.value === '' || field.value === null || field.value === undefined) {
        return;
      }
      
      // 检查输入是否为数字
      if (isNaN(Number(field.value))) {
        this.$message.error('请输入数字');
        // 清空非数字输入
        field.value = '';
        return;
      }
      
      // 确保转换为数字类型
      field.value = Number(field.value);
      
      // 可以添加其他验证逻辑，比如范围验证
      if (field.value < 0) {
        this.$message.error('请输入非负数');
        field.value = '';
      }
      
      console.log('验证后的值:', field.value);
    },

    // 处理管控措施变化
    handleMeasureChange(measure, val) {
      // 使用formMeasureId优先，其次是id
      const measureId = measure.formMeasureId || measure.id || measure.measureId;
      console.log(`管控措施变化: ${measure.measureName}, ID: ${measureId}, 选中: ${val}`);
      
      if (val) {
        if (!this.selectedMeasures.includes(measureId)) {
          this.selectedMeasures.push(measureId);
        }
      } else {
        this.selectedMeasures = this.selectedMeasures.filter(id => id !== measureId);
      }
      
      console.log('当前选中的措施IDs:', this.selectedMeasures);
    },

    // 处理修改报告
    handleEditReport(row) {
      console.log('点击了再次提交按钮，完整行数据:', JSON.stringify(row));
      // 重置已选中的措施
      this.selectedMeasures = [];
      this.selectedFormName = row.formName || '';
      
      // 标记为编辑模式
      this.isEditMode = true;
      
      // 重置提交状态
      this.resetSubmitStatus();
      
      // 获取报告详情，然后初始化编辑表单
      this.loading.submit = true;
      
      // 检查必要的ID
      if (!row.id) {
        console.error('记录ID为空，无法获取详情');
        this.$message.error('记录ID无效，无法再次提交');
        this.loading.submit = false;
        return;
      }
      
      console.log('准备获取报告详情，ID:', row.id);
      
      // 使用更简化、更直接的方式来获取和设置表单数据
      getHealthFormUserDetail(row.id)
        .then(res => {
          console.log('获取报告详情响应:', res);
          
          if (res.code === 200 && res.data) {
            const formData = res.data;
            console.log('获取到的详情数据:', formData);
            
            // 确保formId存在
            if (!formData.formId) {
              console.error('表单ID不存在:', formData);
              this.$message.error('获取表单ID失败，无法再次提交');
              this.loading.submit = false;
              return;
            }

            // 使用另一种方式：直接初始化一个新表单，然后手动设置字段值
            const formId = formData.formId;
            const classId = formData.classId;
            
            // 获取初始化表单数据
            initHealthFormUser(formId, classId).then(initRes => {
              console.log('表单初始化数据:', initRes);
              
              if (initRes.code === 200 && initRes.data) {
                const initData = initRes.data;
                
                // 初始化新的reportForm
                this.reportForm = {
                  executionTime: formData.createTime || this.formatDate(new Date()),
                  team: formData.className || formData.teamName || '生产一组',
                  shift: formData.shiftName || '早班',
                  name: formData.userName || '陈明宇',
                  healthStatus: formData.healthRatingName || '正常',
                  formId: formId,
                  formFields: [],
                  formMeasures: [],
                  otherMeasure: formData.otherMeasure || '',
                  classId: classId,
                  id: row.id // 重要：设置原记录ID，确保更新而非新增
                };
                
                // ====== 处理表单字段 ======
                if (initData.formFields && initData.formFields.length > 0) {
                  // 处理初始化返回的字段
                  const processedFields = initData.formFields.map(field => {
                    // 确保字段ID正确
                    field.formFieldId = field.formFieldId || field.id || field.fieldId;
                    field.id = field.formFieldId;
                    
                    // 确保字段可编辑
                    field.readonly = false;
                    field.disabled = false;
                    
                    // 根据字段类型设置默认值
                    if (field.fieldType === 1) {
                      field.value = '';  // 数字字段初始为空
                    } else if (field.fieldType === 2) {
                      field.value = field.options && field.options.length > 0 ? field.options[0].id : ''; // 选择字段默认选第一个
                  } else {
                      field.value = '';  // 其他字段初始为空
                    }
                    
                    return field;
                  });
                  
                  // 设置处理后的字段到表单
                  this.reportForm.formFields = processedFields;
                  
                  // 从详情数据中提取字段值填充到表单字段
                  if (formData.formFields && formData.formFields.length > 0) {
                    formData.formFields.forEach(detailField => {
                      // 找到对应的表单字段
                      const formField = processedFields.find(f => 
                        f.formFieldId === detailField.formFieldId || 
                        f.id === detailField.id || 
                        f.formFieldName === detailField.formFieldName
                      );
                      
                      if (formField) {
                        // 根据字段类型设置值
                        if (formField.fieldType === 1) { // 数字类型
                          formField.value = detailField.value !== undefined ? Number(detailField.value) : 
                                           (detailField.formFieldOptionValue !== undefined ? Number(detailField.formFieldOptionValue) : '');
                          console.log(`数字字段 ${formField.formFieldName} 设置值: ${formField.value}`);
                        }
                        else if (formField.fieldType === 2) { // 选择类型
                          // 尝试从多个来源获取选项ID
                          let optionId = null;
                          
                          if (detailField.optionId !== undefined) {
                            optionId = detailField.optionId;
                            console.log(`从optionId获取值: ${optionId}`);
                          }
                          else if (detailField.formFieldOptionId !== undefined) {
                            optionId = detailField.formFieldOptionId;
                            console.log(`从formFieldOptionId获取值: ${optionId}`);
                          }
                          else if (detailField.selectedOption && detailField.selectedOption.id) {
                            optionId = detailField.selectedOption.id;
                            console.log(`从selectedOption获取值: ${optionId}`);
                          }
                          else if (detailField.optionName && formField.options) {
                            // 通过名称匹配选项
                            const matchOption = formField.options.find(o => 
                              o.optionName === detailField.optionName || 
                              o.name === detailField.optionName
                            );
                            
                            if (matchOption) {
                              optionId = matchOption.id;
                              console.log(`通过名称匹配找到选项: ${optionId}`);
                            }
                          }
                          
                          // 如果找到选项ID，设置到表单字段
                          if (optionId !== null) {
                            formField.value = optionId;
                            console.log(`选择字段 ${formField.formFieldName} 设置值: ${optionId}`);
                          }
                        }
                        else { // 其他类型字段
                          formField.value = detailField.value || detailField.formFieldOptionValue || '';
                          console.log(`其他字段 ${formField.formFieldName} 设置值: ${formField.value}`);
                        }
                      }
                    });
                  }
                }
                
                // ====== 处理管控措施 ======
                if (initData.formMeasures && initData.formMeasures.length > 0) {
                  // 处理初始化返回的管控措施
                  const processedMeasures = initData.formMeasures.map(measure => {
                    // 确保措施ID正确
                    measure.formMeasureId = measure.formMeasureId || measure.id || measure.measureId;
                measure.id = measure.formMeasureId;
                
                    // 确保措施可编辑
                    measure.readonly = false;
                    measure.disabled = false;
                    
                    // 初始未选中
                measure.checked = false;
                    
                    return measure;
                  });
                  
                  // 设置处理后的措施到表单
                  this.reportForm.formMeasures = processedMeasures;
                  
                  // 重置选中措施列表
                  this.selectedMeasures = [];
                  
                  // 从详情数据中提取选中的措施
                  if (formData.formMeasures && formData.formMeasures.length > 0) {
                    formData.formMeasures.forEach(detailMeasure => {
                      if (detailMeasure.selected === true) {
                        // 找到对应的表单措施
                        const formMeasure = processedMeasures.find(m => 
                          m.formMeasureId === detailMeasure.formMeasureId || 
                          m.id === detailMeasure.id || 
                          m.measureName === detailMeasure.measureName
                        );
                        
                        if (formMeasure) {
                          // 标记为选中
                          formMeasure.checked = true;
                          const measureId = formMeasure.formMeasureId || formMeasure.id;
                          if (measureId && !this.selectedMeasures.includes(measureId)) {
                            this.selectedMeasures.push(measureId);
                          }
                          console.log(`措施 ${formMeasure.measureName} 标记为选中`);
                        }
                      }
                    });
                  }
                  
                  // 如果没有找到选中的措施，尝试从措施内容中匹配
                  if (this.selectedMeasures.length === 0 && row.controlMeasure) {
                    const measureText = row.controlMeasure;
                    const measureNames = measureText.split(/[,，、]/);
                    
                    processedMeasures.forEach(measure => {
                      for (const name of measureNames) {
                        const trimmedName = name.trim().replace(/\s+等\d+项$/, '');
                        if (measure.measureName.includes(trimmedName) || trimmedName.includes(measure.measureName)) {
                    measure.checked = true;
                          const measureId = measure.formMeasureId || measure.id;
                          if (measureId && !this.selectedMeasures.includes(measureId)) {
                    this.selectedMeasures.push(measureId);
                          }
                          console.log(`通过内容匹配找到措施: ${measure.measureName}`);
                          break;
                        }
                  }
                });
              }
            }
            
                // 设置弹窗标题
                this.selectedFormName = `${formData.formName || '健康填报'} (再次提交)`;
                
                // 最终确认并记录ID信息
                console.log(`确认再次提交模式：原始记录ID=${row.id}，表单ID=${this.reportForm.id}，确保执行修改而非新增`);
                // 再次确认编辑模式标记已设置
                this.isEditMode = true;
                
                // 打开弹窗
            this.reportDialogVisible = true;
                
                // 确保视图更新并可编辑
                this.$nextTick(() => {
                  // 强制更新视图
                  this.$forceUpdate();
                  
                  // 输出最终状态用于调试
                  console.log('表单最终状态: ', {
                    formFields: this.reportForm.formFields.map(f => ({
                      name: f.formFieldName,
                      type: f.fieldType,
                      value: f.value,
                      editable: !f.readonly && !f.disabled
                    })),
                    formMeasures: this.reportForm.formMeasures.map(m => ({
                      name: m.measureName,
                      checked: m.checked,
                      editable: !m.readonly && !m.disabled
                    }))
                  });
                });
          } else {
                this.$message.error('获取表单结构失败');
              }
              
              this.loading.submit = false;
            }).catch(error => {
              console.error('获取表单初始化数据失败:', error);
              this.$message.error('获取表单初始化数据失败');
              this.loading.submit = false;
            });
          } else {
            console.error('获取报告详情失败:', res);
            this.$message.error('获取报告详情失败');
            this.loading.submit = false;
          }
        }).catch(error => {
          console.error('获取报告详情请求失败:', error);
          this.$message.error('获取报告详情失败');
          this.loading.submit = false;
        });
    },
    // 初始化报表数据
    async initReportForm(formId, classId) {
      if (!formId) {
        this.$message.error('表单ID不能为空')
        return
      }
      
      this.loading.submit = true
      
      try {
        console.log('初始化表单数据:', {
          formId,
          classId
        })
        
        // 获取表单初始化数据
        const res = await initHealthFormUser(formId, classId)
        
        if (res.data) {
          const formData = res.data
          
          // 日志输出表单字段情况
          if (formData.formFields && formData.formFields.length > 0) {
            console.log('初始化时的表单字段数据:', formData.formFields)
            formData.formFields.forEach((field, index) => {
              // 确保每个字段都有formFieldId
              const fieldId = field.formFieldId || field.id || field.fieldId
              if (!fieldId) {
                console.warn(`字段[${index}] ${field.formFieldName} 没有有效的ID`)
                field.id = `temp-field-${index}`
              } else {
                console.log(`初始字段[${index}]: ${field.formFieldName}, id来源: ${field.formFieldId ? 'formFieldId' : (field.id ? 'id' : 'fieldId')}`)
                field.id = fieldId
              }
              
              // 初始化字段选项
              field.options = field.options || []
            })
          }
          
          // 日志输出管控措施情况
          if (formData.formMeasures && formData.formMeasures.length > 0) {
            console.log('初始化时的管控措施数据:', formData.formMeasures)
            formData.formMeasures.forEach((measure, index) => {
              console.log(`初始措施[${index}]: ${measure.measureName}, id: ${measure.id}, measureId: ${measure.measureId}`)
            })
          }
          
          // 更新表单数据
          this.reportForm.formFields = formData.formFields || []
          this.reportForm.formMeasures = formData.formMeasures || []
          
          // 初始化管控措施选中状态
          if (this.reportForm.formMeasures && this.reportForm.formMeasures.length > 0) {
            this.selectedMeasures = []
            this.reportForm.formMeasures.forEach(measure => {
              // 确保每个措施都有id
              const measureId = measure.formMeasureId || measure.id || measure.measureId
              if (!measureId) {
                console.warn(`措施 ${measure.measureName} 没有有效的ID`)
                measure.id = `temp-measure-${Math.random().toString(36).substr(2, 9)}`
              } else {
                // 使用第一个有效ID
                if (measure.formMeasureId) {
                  console.log(`措施 ${measure.measureName} 使用formMeasureId: ${measure.formMeasureId}`)
                } else if (measure.id) {
                  console.log(`措施 ${measure.measureName} 使用id: ${measure.id}`)
                } else {
                  console.log(`措施 ${measure.measureName} 使用measureId: ${measure.measureId}`)
                }
                measure.id = measureId
              }
              
              // 初始化checked为false
              measure.checked = false
            })
          }
        }
      } catch (error) {
        console.error('获取表单数据失败', error)
        this.$message.error('获取表单数据失败')
      } finally {
        this.loading.submit = false
      }
    },
    
    // 获取当日填报状态
    async fetchDailyReportStatus() {
      if (this.dailyReportStatus.loading) return;
      this.dailyReportStatus.loading = true;
      
      try {
        const res = await getDailyReportStatus();
        if (res.code === 200) {
          // 从原始API返回中转换数据格式
          const availableCount = res.data ? res.data.length : 0;
          // 设置为"已完成"状态，如果没有可填报的表单
          this.dailyReportStatus.completed = availableCount === 0;
          // 设置待填报数量
          this.dailyReportStatus.pendingCount = availableCount;
          
          console.log('当日填报状态:', {
            availableCount,
            completed: this.dailyReportStatus.completed,
            pendingCount: this.dailyReportStatus.pendingCount
          });
        }
      } catch (error) {
        console.error('获取当日填报状态失败', error);
      } finally {
        this.dailyReportStatus.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.daily-report-container {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 标签页样式 */
.report-tabs {
  display: flex;
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 20px;
}

.tab-item {
  padding: 0 20px 15px;
  margin-right: 20px;
  font-size: 16px;
  cursor: pointer;
  color: #606266;
  position: relative;
}

.tab-item.active {
  color: #409EFF;
  font-weight: 500;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #409EFF;
}

/* 筛选区域样式 */
.filter-section {
  margin-bottom: 20px;
}

.filter-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
}

.filter-input, .filter-select, .filter-item {
  width: 150px;
}

.date-picker-input {
  width: 280px;
}

.filter-button {
  margin: 0;
}

.spacer {
  flex-grow: 1;
}

.report-btn {
  min-width: 130px;
  
  &.is-disabled {
    color: #909399;
    background-color: #f4f4f5;
    border-color: #e9e9eb;
    cursor: not-allowed;
  }
}

/* 表格状态样式 */
.status-normal {
  color: #67C23A;
}

.status-reported {
  color: #67C23A;
}

.status-pending {
  color: #E6A23C;
}

/* 分页容器 */
.pagination-container {
  margin-top: 20px;
  text-align: right;
}

/* 弹窗样式 */
.health-detail-dialog .el-dialog__header,
.health-report-dialog .el-dialog__header,
.health-approval-dialog .el-dialog__header {
  padding: 15px 20px;
  border-bottom: 1px solid #e4e7ed;
}

.health-detail-dialog .el-dialog__body,
.health-report-dialog .el-dialog__body,
.health-approval-dialog .el-dialog__body {
  padding: 20px;
}

.detail-content,
.report-content,
.approval-content {
  padding: 0 10px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.section-title:first-child {
  margin-top: 0;
}

.required {
  color: #f56c6c;
  margin-left: 4px;
}

.detail-row,
.report-row,
.approval-row {
  display: flex;
  margin-bottom: 15px;
}

.detail-item,
.report-item,
.approval-item {
  flex: 1;
  display: flex;
  align-items: baseline;
}

.detail-item.full-width,
.report-item.full-width,
.approval-item.full-width {
  flex: 2;
}

.detail-label,
.report-label,
.approval-label {
  width: 80px;
  color: #606266;
  text-align: left;
}

.detail-value,
.report-value,
.approval-value {
  flex: 1;
  color: #303133;
  text-align: left;
}

.detail-value.score,
.approval-value.score {
  font-size: 24px;
  font-weight: bold;
  color: #409EFF;
}

.process-timeline {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.process-item {
  display: flex;
  margin-bottom: 15px;
  position: relative;
  padding-left: 15px;
}

.process-item:before {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #409EFF;
}

.process-time {
  width: 180px;
  color: #909399;
}

.process-user {
  width: 100px;
  color: #606266;
}

.process-action {
  color: #303133;
}

/* 填报表单特有样式 */
.checkbox-item {
  margin-bottom: 10px;
  text-align: left;
}

.el-checkbox {
  margin-left: 0;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .filter-row {
    flex-wrap: wrap;
  }
  
  .spacer {
    display: none;
  }
  
  .report-btn {
    margin-top: 10px;
    width: 100%;
  }
  
  .filter-input, .filter-select, .filter-item {
    width: 100%;
  }
  
  .detail-row,
  .report-row,
  .approval-row {
    flex-direction: column;
  }
  
  .detail-item,
  .report-item,
  .approval-item {
    margin-bottom: 10px;
  }
  
  .process-item {
    flex-direction: column;
  }
  
  .process-time, .process-user {
    width: auto;
    margin-bottom: 5px;
  }
}

/* 表单选择弹窗样式 */
.select-form-dialog .el-dialog__body {
  padding: 20px;
}

.select-form-content {
  width: 100%;
}

.form-cards-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 100%;
}

.form-card {
  cursor: pointer;
  transition: all 0.3s;
  margin: 0;
  box-sizing: border-box;
}

.form-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.form-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.form-name {
  font-weight: bold;
  font-size: 16px;
  color: #303133;
}

.form-card-content {
  padding-top: 10px;
}

.form-item {
  display: flex;
  margin-bottom: 8px;
  align-items: baseline;
  color: #606266;
}

.form-label {
  min-width: 70px;
  color: #909399;
}

.form-value {
  color: #303133;
}

.empty-state {
  width: 100%;
  padding: 40px 0;
  text-align: center;
  color: #909399;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 10px;
}

/* 管控措施样式 */
.measure-list {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.measure-item {
  margin-bottom: 12px;
  padding: 8px 0;
  border-bottom: 1px dashed #ebeef5;
  text-align: left;
}

.measure-item:last-child {
  border-bottom: none;
}

.detail-value.score {
  font-size: 24px;
  font-weight: bold;
  color: #409EFF;
}

.detail-label-top {
  color: #606266;
  text-align: left;
  margin-bottom: 8px;
  display: block;
}

.detail-column {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.detail-textarea {
  flex: 1;
  min-height: 60px;
  padding: 10px;
  background-color: #f7f7f7;
  border-radius: 4px;
  margin-top: 5px;
  color: #303133;
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.5;
}
</style> 